import * as React from 'react';

const useLiteUpgradeDialog = () => {
  const [showLiteUpgradeDialog, setShowLiteUpgradeDialog] =
    React.useState(false);
  const closeLiteUpgradeDialog = () => setShowLiteUpgradeDialog(false);
  const openLiteUpgradeDialog = () => setShowLiteUpgradeDialog(true);
  return {
    showLiteUpgradeDialog,
    closeLiteUpgradeDialog,
    openLiteUpgradeDialog
  };
};

export default useLiteUpgradeDialog;
